(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TranslationDetailController', TranslationDetailController);

    TranslationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Translation'];

    function TranslationDetailController($scope, $rootScope, $stateParams, entity, Translation) {
        var vm = this;

        vm.translation = entity;

        var unsubscribe = $rootScope.$on('portalApp:translationUpdate', function(event, result) {
            vm.translation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
